import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import style from "./styles.module.scss";
import { LoadingMessage } from "../Authorization/Processes";
import List from "./List";

const AuthorizationList = ({ open, toggle, process, processId, services }) => {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    setLoading(true);
    if (process && processId) {
      services
        .getAuthorizations({
          refProcess: process,
          refId: processId,
        })
        .then((res) => res.authorizations)
        .then((auths) => {
          setItems(auths);
          setLoading(false);
        });
    }
  }, [process, processId]);

  return (
    <Modal isOpen={open} className={style.modal}>
      <ModalHeader toggle={toggle} className={style.header} style={{ padding: "10px 15px" }}>
        Authorizations
      </ModalHeader>
      <ModalBody>
        {loading ? <LoadingMessage text="Loading authorizations" /> : <List items={items} />}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={() => toggle()}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AuthorizationList;
